<template>
  <div class="status font-28 c-191F25-56">
    <div
      v-for="(record, index) in computedRecords"
      :key="index"
      :is-not-first="index > 0"
      :status="record.checkInState"
    >
      <div>
        <span class="c-191F25">{{ `打卡时间${record.attendanceTime}` }}</span>
        <!-- <span>{{`(上学时间${record.attendanceTimeSt})`}}</span> -->
      </div>
      <div>
        <span><i class="iconfont c-191F25-28">&#xe70d;</i></span>
        <span>{{ record.deviceName }}</span>
      </div>
      <div>
        <img :src="record.catchImage" />
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/comUtils'
export default {
  name: 'commonTime',
  components: {},
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      date: ''
    }
  },
  computed: {
    computedRecords() {
      let _records = this.records.map(item => {
        let _item = { ...item }
        _item.attendanceTime = timeFormat(
          new Date(Number(item.checkInTime)),
          'hh:mm'
        )
        // _item.attendanceTimeSt = item.stCheckInTime.split(' ').slice(1, 4)
        return _item
      })
      return _records
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.status {
  > div {
    height: 200px;
    padding-left: 20px;
    position: relative;
    &:before {
      content: '';
      width: 16px;
      height: 16px;
      text-align: center;
      background: #b4b4b4;
      position: absolute;
      top: 14px;
      left: 0;
      border-radius: 50%;
    }
    // &[status="1"]:before {
    //   content: "上";
    //   font-size: 12px;
    //   width: 16px;
    //   height: 16px;
    //   text-align: center;
    //   background: #b4b4b4;
    //   position: absolute;
    //   top: 14px;
    //   left: 0;
    //   border-radius: 50%;
    // }
    // &[status="2"]:before {
    //   content: "下";
    //   font-size: 12px;
    //   width: 16px;
    //   height: 16px;
    //   text-align: center;
    //   background: #b4b4b4;
    //   position: absolute;
    //   top: 14px;
    //   left: 0;
    //   border-radius: 50%;
    // }
    &[is-not-first='true']:after {
      content: '';
      width: 2px;
      height: 184px;
      text-align: center;
      background: #b4b4b4;
      position: absolute;
      bottom: 186px;
      left: 7px;
    }
    > div {
      padding-top: 12px;
      > img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
